export default [
  {
    path: '/assignment/manage-partners',
    name: 'assignment-manage-partners',
    component: () => import('@/views/pages/assignment/manage-partner/List.vue'),
    meta: {
      name: 'Kelola Partner',
      routeCreate: 'assignment-partners-create',
      routeShow: 'assignment-partners-show',
      resource: 'Komtim - Assignment',
      action: 'manage',
    },
  },
  {
    path: '/assignment/manage-partners/create',
    name: 'assignment-partners-create',
    component: () => import('@/views/pages/assignment/manage-partner/AddOrDetail.vue'),
    meta: {
      name: 'Assign Partner',
      navActiveLink: 'assignment-manage-partners',
      resource: 'Komtim - Assignment',
      action: 'manage',
    },
  },
  {
    path: '/assignment/manage-partners/:id/show',
    name: 'assignment-partners-show',
    component: () => import('@/views/pages/assignment/manage-partner/AddOrDetail.vue'),
    meta: {
      name: 'Detail Partner',
      navActiveLink: 'assignment-manage-partners',
      resource: 'Komtim - Assignment',
      action: 'manage',
    },
  },
]
